import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { QUESTIONS } from 'src/constants/messages'
import { LOAN_TERM_MESSAGES } from 'src/constants/loan'
import { If } from 'src/Components'
import RefiRequest from 'src/Components/shared/InterestSection/Refinance/RefiRequest'
import RefiMessages from 'src/Components/shared/InterestSection/RefiByYearsInHome/RefiMessages'

import styles from './RefiDetailsOverlay.module.scss'

const propTypes = {
  type: PropTypes.string,
  years: PropTypes.number
}

const RefiRequestButton = ({ type, years, className }) => (
  <If condition={type && years}>
    <RefiRequest
      withPrimaryButton
      className={classnames(styles.sendButton, className)}
      messageProps={{
        ...QUESTIONS.refiDetailsCheck,
        values: {
          label: <RefiMessages.LoanName type={type} years={years} />
        }
      }}
      label={LOAN_TERM_MESSAGES[type.toLowerCase()].defaultMessage.replace(
        '{years}',
        years
      )}
    />
  </If>
)

RefiRequestButton.propTypes = propTypes

export default RefiRequestButton
